import React from 'react';
import { ApolloError } from '@apollo/client';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

interface AccountDetailPhoneNumberProps {
  error?: ApolloError;
  phoneNumber: string | null;
}

export const AccountDetailPhoneNumber: React.FC<
  AccountDetailPhoneNumberProps
> = ({ error, phoneNumber }) => {
  const theme = useTheme();

  if (error || !phoneNumber) {
    return null;
  }

  return (
    <Typography color={theme.sk.color.text.secondary} variant="paragraph-md">
      {phoneNumber}
    </Typography>
  );
};
